import { render, staticRenderFns } from "./AuctionDescription.vue?vue&type=template&id=5be3e7b8&scoped=true"
import script from "./AuctionDescription.vue?vue&type=script&lang=js"
export * from "./AuctionDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be3e7b8",
  null
  
)

export default component.exports